import { Avatar, Box, Stack, Typography } from '@mui/material';

import { AccordionWithHeading, ContentLoading } from '../../../components/general';
import { HeadingWithTag } from '../../../components/general/HeadingWithTag.tsx';
import { type TerminProps } from '../../../utils';
import { content } from './TerminAnsprechpartnerCard.content';
import { printFachkraft, printPM, printTeamPlanning } from './TerminAnsprechpartnerCard.utils';

export const TerminAnsprechpartnerCard = ({ thema }: TerminProps) => {
  if (!thema.planungsinformation) {
    return (
      <AccordionWithHeading heading={content.heading}>
        <ContentLoading />
      </AccordionWithHeading>
    );
  }

  const data = [
    [content.fields.pm, printPM(thema)],
    [content.fields.fachkraft, printFachkraft(thema)],
    [content.fields.teamPlanning, printTeamPlanning(thema)],
  ];

  return (
    <AccordionWithHeading heading={<HeadingWithTag heading={content.heading} tag="cserv" />} noAccordion>
      <Stack direction="row" justifyContent="space-between">
        {data.map(([label, value]) => (
          <Stack key={label} spacing={0.5} mb={2} flexGrow={1}>
            <Typography variant="labelSmLight" color="textTertiary">
              {label}
            </Typography>
            <Box display="flex" alignItems="center" gap={2}>
              <Avatar>{value.split(' ').map((w) => w[0])}</Avatar>
              <Typography variant="paragraph">{value}</Typography>
            </Box>
          </Stack>
        ))}
      </Stack>
    </AccordionWithHeading>
  );
};
